import { FONT_WEIGHT_OPTIONS, sizeTokenOptions, sizeTokenOptionsWithDefault, TITLE_LEVEL_OPTIONS, UI_FIELD_DEFAULT_OPTION, } from './token-options.js';
export const DIALOG_FIELDS = [
    {
        key: 'dialog.radius',
        label: '모서리 둥글기',
        help: '확인·안내 창(가운데에 뜨는 작은 창) 네 모서리의 둥글기입니다. 기본은 지금 모양(앱 14px · 모바일 웹 16px)입니다.',
        group: '창',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('radius', '앱 14px · 모바일 웹 16px'),
    },
    {
        key: 'dialog.padding',
        label: '안쪽 여백',
        help: '확인·안내 창 테두리와 제목·본문·버튼 사이의 여백(상하좌우 같음)입니다. 기본은 지금 여백(앱 21px · 모바일 웹 24px)입니다.',
        group: '창',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '앱 21px · 모바일 웹 24px'),
    },
    {
        key: 'dialog.maxWidth',
        label: '최대 너비',
        help: '확인·안내 창이 넓어질 수 있는 최대 너비입니다. 좁은 화면에서는 화면 좌우에 여백을 두고 그보다 좁아집니다(최소 240px).',
        group: '창',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: 300,
        min: 240,
        max: 400,
    },
    {
        key: 'dialog.backdrop.opacity',
        label: '뒤 배경 어둡기',
        help: '확인·안내 창이 떠 있을 때 뒤 화면을 덮는 검은 막의 진하기입니다.',
        group: '창',
        type: 'enum',
        defaultValue: '50',
        options: ['30', '40', '50', '60', '70'].map((value) => ({ value, label: `${value}%` })),
    },
    {
        key: 'dialog.title.level',
        label: '제목 글자 크기',
        help: '확인·안내 창 맨 위 제목의 글자 크기입니다.',
        group: '글자',
        type: 'enum',
        defaultValue: '3',
        options: TITLE_LEVEL_OPTIONS,
    },
    {
        key: 'dialog.title.weight',
        label: '제목 굵기',
        help: '확인·안내 창 제목의 글자 굵기입니다.',
        group: '글자',
        type: 'enum',
        defaultValue: 'semibold',
        options: FONT_WEIGHT_OPTIONS,
    },
    {
        key: 'dialog.body.fontSize',
        label: '본문 글자 크기',
        help: '확인·안내 창 제목 아래 설명 글의 크기입니다.',
        group: '글자',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.sm',
        min: 11,
        max: 19,
    },
    {
        key: 'dialog.button.height',
        label: '버튼 높이',
        help: '확인·취소 버튼의 높이입니다. 기본은 지금처럼 버튼 글자에 맞춘 높이입니다.',
        group: '버튼',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: [
            { value: UI_FIELD_DEFAULT_OPTION, label: '기본 (글자에 맞춤)' },
            ...sizeTokenOptions('dimension').filter((option) => ['l', 'l-plus', 'xl', 'xl-plus', '2xl'].includes(option.value)),
        ],
    },
    {
        key: 'dialog.button.radius',
        label: '버튼 모서리 둥글기',
        help: '확인·취소 버튼 모서리의 둥글기입니다. 기본은 지금 모양(m — 앱 10.5px · 모바일 웹 12px)입니다.',
        group: '버튼',
        type: 'enum',
        defaultValue: 'm',
        options: [
            { value: 's', label: 's (앱 7px · 모바일 웹 8px)' },
            { value: 's-plus', label: 's-plus (10px)' },
            { value: 'm', label: '기본 — m (앱 10.5px · 모바일 웹 12px)' },
            { value: 'm-plus', label: 'm-plus (16px)' },
            { value: 'l', label: 'l (20px)' },
            { value: 'full', label: 'full (완전 둥글게)' },
        ],
    },
    {
        key: 'dialog.button.fontSize',
        label: '버튼 글자 크기',
        help: '확인·취소 버튼 글자의 크기입니다.',
        group: '버튼',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.sm',
        min: 11,
        max: 19,
    },
];
//# sourceMappingURL=dialog.js.map